import React from "react";
import PropertyRecordsImporterErrors from "./PropertyRecordsImporterErrors";
import ImportSelect from "./ImportSelect"

export default class AssignCustomerDetails extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      this.renderCustomerFields()
    );
  };

  renderCustomerFields(){

    return(
      <div className="assign-details-wrapper">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-2">
            <label>Table Column</label>
          </div>
          <div className="col-md-3">
            <label>CSV Column</label>
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('salutation')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('salutation')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('first_name')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('first_name')}
            {this.renderFieldErrors('first_name')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('middle_name')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('middle_name')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('last_name')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('last_name')}
            {this.renderFieldErrors('last_name')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('email')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('email')}
            {this.renderFieldErrors('email')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('phone_number')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('phone_number')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('address_1')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('address_1')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('address_2')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('address_2')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('city')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('city')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('state')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('state')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('country')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('country')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('postal_code')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('postal_code')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('marketing_opt_in')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('marketing_opt_in')}
          </div>
        </div>
      </div>
    );
  };

  renderHeadersSelect(selectName) {
    return (
      <ImportSelect name={selectName} options={this.props.fileHeaders} option={this.props.customer[selectName]} onChange={this.props.onChange} error={this.renderFieldErrors(selectName)}/>
    );
  };

  renderErrors() {
    var errors = PropertyRecordsImporterErrors.customers(this.props.errors);
    
    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => { 
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = "";
    } else {
      var classname = "form-control";
    }
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  }
};
